export function isGhanaBusiness(store) {
  const business = store?.state?.user?.user_infor?.current_business;
  return business?.country?.code === "GH";
}

export function canManageEvat(store) {
  const user = store?.state?.user?.user_infor;
  if (!user) return false;
  return user.is_admin === 1 || user.invite?.accountant_id != null;
}

export function isEvatLocked(evat) {
  if (!evat) return false;
  return evat.can_submit === false;
}

export function formatTaxIdType(value, types = []) {
  if (!value) return "";
  const match = types.find((type) => type.value === value);
  if (match?.label) return match.label;
  return String(value)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export const EVAT_SETUP_STEPS = [
  {
    key: "company_reference",
    label: "Company reference",
    description: "GRA-issued company reference saved",
  },
  {
    key: "security_key",
    label: "Security key",
    description: "Security key saved securely",
  },
  {
    key: "tax_mapping",
    label: "Tax mapping",
    description: "At least one tax mapped to a GRA levy bucket",
  },
  {
    key: "connection_verified",
    label: "Connection verified",
    description: "Credentials tested successfully with GRA",
  },
];

export const EVAT_SETUP_LABELS = {
  company_reference: "Company reference",
  security_key: "Security key",
  tax_mapping: "Tax mapping",
  connection_verified: "Connection verified",
  business_name: "Business name",
  gra_branch: "GRA branch",
  tin: "TIN",
};

export const EVAT_STATUS_LABELS = {
  draft: "Pending",
  submitting: "Submitting",
  submitted: "Submitted",
  failed: "GRA submission failed",
};

export const EVAT_SKIP_REASON_LABELS = {
  not_found: "Document not found",
  not_retryable: "Not eligible for retry",
  already_submitted: "Already submitted to GRA",
  already_queued: "Already queued for submission",
  submitting: "Submission already in progress",
  not_eligible: "Not eligible for E-VAT submission",
  evat_disabled: "E-VAT is not enabled for this document",
  locked: "Document cannot be edited or resubmitted",
};

export function formatEvatSkipReason(reason) {
  if (!reason) return "Skipped";
  if (EVAT_SKIP_REASON_LABELS[reason]) return EVAT_SKIP_REASON_LABELS[reason];
  return String(reason)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getEvatBulkEndpoint(documentType, mode = "submit") {
  if (mode === "retry" && documentType === "submissions") {
    return "/api/evat/submissions/retry";
  }
  return `/api/evat/${documentType}/submit`;
}

export function normalizeEvatBulkResponse(data) {
  return {
    success: data?.success ?? true,
    message: data?.message || "",
    queued: Array.isArray(data?.queued) ? data.queued : [],
    skipped: Array.isArray(data?.skipped) ? data.skipped : [],
  };
}

const DOCUMENT_LABELS = {
  invoices: "invoice",
  sales: "sale",
  bills: "bill",
  submissions: "submission",
};

const DOCUMENT_LABELS_PLURAL = {
  invoices: "invoices",
  sales: "sales",
  bills: "bills",
  submissions: "submissions",
};

export function getEvatDocumentLabel(documentType, count = 1) {
  if (count === 1) {
    return DOCUMENT_LABELS[documentType] || "document";
  }
  return DOCUMENT_LABELS_PLURAL[documentType] || "documents";
}
